import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ButtonOption } from "../../../components/datatable/datatablecolumn/datatablecolumn.component";
import {
    LookupValue,
    LookupValuesService,
} from "../../../services/settings/lookupvalues.service";
import { SubContractorsService } from "../../../services/settings/subContractor.service";

@Component({
    standalone: false,
    selector: "lookupvalue-table",
    templateUrl: "./lookupvalues.view.component.html",
    providers: [LookupValuesService, SubContractorsService],
})
export class SettingsLookupValue {
    @Input() type: string;
    @Input() header: string;
    elements: LookupValue[];
    options: ButtonOption[] = [];
    blockDeactivate = ["SubContractorPaymentTerms", "SubContractorPackage"];

    constructor(
        private router: Router,
        private service: LookupValuesService,
        private subContractorsService: SubContractorsService
    ) {}

    ngOnInit() {
        this.options = [
            {
                value: "Deactivate",
                click: (controller, id, row) => this.deactivate(row),
                hide: (row: LookupValue, totalRowCount: number) =>
                    row.status != "Active" ||
                    row.isDefault == true ||
                    (row.inUse && this.blockDeactivate.indexOf(this.type) > -1),
            },
            {
                value: "Activate",
                click: (controller, id, row) => this.activate(row),
                hide: (row: LookupValue, totalRowCount: number) =>
                    row.status == "Active",
            },
            {
                value: "Delete",
                hide: (row: LookupValue, totalRowCount: number) =>
                    row.isDefault == true ||
                    (row.inUse && this.blockDeactivate.indexOf(this.type) > -1),
                click: (controller, id, row) => this.delete(row),
            },
        ];
        this.refreshTable();
    }

    refreshTable() {
        this.refresh();
    }

    private async refresh() {
        this.elements = await this.service
            .getLookupValues(this.type)
            .toPromise();
    }

    private activate(row: LookupValue) {
        this.service.activateLookupValue(row.id).subscribe(null, null, () => {
            this.refreshTable();
        });
    }

    private deactivate(row: LookupValue) {
        this.service.deactivateLookupValue(row.id).subscribe(null, null, () => {
            this.refreshTable();
        });
    }

    private delete(row: LookupValue) {
        this.service.deleteLookupValue(row.id).subscribe(null, null, () => {
            this.refreshTable();
        });
    }
}
